// ----------------------------------------------------------------------
// <copyright file="Izenda.Thinkness.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 *  Height Setting component
 */
!(function() {
  var UIConstants = require('logic/data/Izenda.UIConstants');
  var React = require('react');
  var NumericInput = require('share/components/controls/Izenda.NumericInput');

  var Thinkness = React.createClass({
    propTypes: {
      value: React.PropTypes.number,
      onChange: React.PropTypes.func,
      disabled: React.PropTypes.bool
    },

    getInitialState: function () {
      return {
        value: this.props.value || UIConstants.borderWidth
      };
    },

    onValueChange: function (newValue) {
      var props = this.props;
      this.setState({
        value: newValue
      });

      props.onChange && props.onChange({value: newValue});
    },

    componentWillReceiveProps: function (nextProps) {
      this.setState({
        value: nextProps.value
      });
    },

    render: function () {
      return (
        <div className='thinkness input-group'>
          <NumericInput value={this.state.value}
                        onChange={this.onValueChange}
                        min={UIConstants.borderWidthMin}
                        max={UIConstants.borderWidthMax}
                        disabled={this.props.disabled}/>
          <div className='input-group-addon'>px</div>
        </div>
      );
    }
  });

  module.exports = Thinkness;
}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Thinkness.jsx